import axios from '../axios'

// モジュール内教材の並び替え（material_ids: 新しい順のID配列）
const reorderModuleMaterialsApi = async (moduleId, materialIds) => {
  return await axios.put(`api/lms/modules/${moduleId}/materials/reorder`, { material_ids: materialIds })
}

export default reorderModuleMaterialsApi
